import { getContext } from '@fiverr-private/fiverr_context';

export const inBusinessExperience = () => {
    const { experience } = getContext();

    return Boolean(experience && experience.isBusiness);
};
